import UuDetailContent from "../../../components/layouts/ncb_interpol/UuDetailContent";

import React from "react";

const UUDetail: React.FC = () => {
  return (
    <div>
      <UuDetailContent />
    </div>
  );
};

export default UUDetail;
